import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { X, Send } from "lucide-react";
import { toast } from "sonner";
import { photoSrc } from "@/components/RoomPhotosUploader";

export const directConversationId = (a, b) => `direct:${[a, b].sort().join(":")}`;

export default function MessagingDrawer({ bookingId, onClose, bookings = [], otherId: otherIdProp, title }) {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const booking = bookings.find((b) => b.id === bookingId);

  const otherId = otherIdProp || (booking ? (
    user.role === "room_manager" ? (booking.coach_id || booking.client_id)
      : booking.manager_id
  ) : null);

  const load = () => api.get("/messages", { params: { booking_id: bookingId } }).then((r) => setMessages(r.data)).catch(() => {});

  useEffect(() => { load(); const t = setInterval(load, 6000); return () => clearInterval(t); }, [bookingId]);

  const send = async () => {
    if (!text.trim() || !otherId) return;
    try {
      await api.post("/messages", { booking_id: bookingId, to_user_id: otherId, body: text });
      setText(""); load();
    } catch { toast.error("Erreur envoi"); }
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-end" onClick={onClose}>
      <div className="w-full max-w-md bg-white h-full shadow-2xl flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="messaging-drawer">
        <div className="p-4 border-b border-slate-200 flex justify-between items-center">
          <div>
            <div className="font-bold text-slate-900">Messagerie</div>
            <div className="text-xs text-slate-500">{title || booking?.room?.name}</div>
          </div>
          <button data-testid="close-chat" onClick={onClose} className="p-2 rounded-full hover:bg-slate-100"><X className="w-4 h-4" /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {messages.map((m) => {
            const mine = m.from_user_id === user.id;
            return (
              <div key={m.id} className={`flex items-end gap-2 ${mine ? "justify-end" : ""}`}>
                {!mine && (m.from_photo
                  ? <img src={photoSrc(m.from_photo)} alt="" className="w-7 h-7 rounded-full object-cover border border-slate-200" />
                  : <div className="w-7 h-7 rounded-full bg-slate-200" />)}
                <div className={`max-w-[80%] px-3 py-2 rounded-2xl text-sm ${mine ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-800"}`}>
                  {m.body}
                </div>
              </div>
            );
          })}
          {messages.length === 0 && <div className="text-sm text-slate-500 text-center pt-8">Aucun message. Écrivez le premier !</div>}
        </div>
        <div className="p-3 border-t border-slate-200 flex gap-2">
          <input data-testid="chat-input" className="flex-1 border border-slate-200 rounded-full px-4 py-2 text-sm" placeholder="Votre message…" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} />
          <button data-testid="chat-send" onClick={send} className="sc-btn sc-btn-emerald"><Send className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
}
